import {
     ADD_ADMIN_SELLING_GROUP_CATEGORY,
     ADD_ADMIN_SELLING_GROUP_CATEGORIES,
     UPDATE_ADMIN_SELLING_GROUP_CATEGORY,
     DELETE_ADMIN_SELLING_GROUP_CATEGORY
} from './action';

const initialState = [];

const sellingGroupCategoryReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_ADMIN_SELLING_GROUP_CATEGORY: {
               const newSellingGroupCategoryList = [...state];
               newSellingGroupCategoryList.push(action.payload);
               return newSellingGroupCategoryList;
          }

          case ADD_ADMIN_SELLING_GROUP_CATEGORIES: {
               return action.payload;
          }

          case UPDATE_ADMIN_SELLING_GROUP_CATEGORY: {
               const sellingGroupCategoryList = [...state];
               const newSellingGroupCategoryList = [];
               for (let i = 0; i < sellingGroupCategoryList.length; i++) {
                    const sellingGroupCategory = sellingGroupCategoryList[i];
                    if (sellingGroupCategory.id === action.payload.id) {
                         newSellingGroupCategoryList.push(action.payload);
                         continue;
                    }
                    newSellingGroupCategoryList.push(sellingGroupCategory);
               }
               return newSellingGroupCategoryList;
          }

          case DELETE_ADMIN_SELLING_GROUP_CATEGORY: {
               const sellingGroupCategoryList = [...state];
               return sellingGroupCategoryList.filter(sellingGroupCategory => sellingGroupCategory.id !== action.payload);
          }

          default:
               return state;
     }
}

export const getSellingGroupCategoryById = (state, sid) => {
     return state.admin.sellingGroupCategories.filter((sellingGroupCategory) => sellingGroupCategory.id === sid)[0];
}

export default sellingGroupCategoryReducer;